import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { getRetailerByIdApi } from "api";
import { Select } from 'antd';
import debounce from 'lodash.debounce';
import ClipLoader from "react-spinners/ClipLoader";
import "./style.scss";

export const SearchByMultipleRetailer = ({
  isLoading,
  func,
  onSelect,
  retailerIds,
  fsiRetailerIds,
  styles,
  containerStyle,
  placeholder = 'Search By Multiple Retailers',
  
}) => {
  const [options, setOptions] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [selectedValue, setSelectedValue] = useState([])

  const fetchRetailers = async () => {
    const retailerIdList = (
      fsiRetailerIds
        ? fsiRetailerIds.split(',')
        : Array.isArray(retailerIds)
          ? retailerIds.map((item) => item?.value ?? item)
          : []
    )
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);

    if (!retailerIdList.length) {
      setSelectedValue([]);
      return;
    }

    const selectedRetailers = [];
    for (const id of retailerIdList) {
      const res = await getRetailerByIdApi(id);
      if (res.success) {
        selectedRetailers.push({ label: res.results.name, value: res.results.id });
      }
    }
    setSelectedValue(selectedRetailers);
  };
  

  useEffect(() => {
    fetchRetailers();
  }, [retailerIds, fsiRetailerIds]);

  // Debounced fetch
  const debouncedFetch = useMemo(() => 
    debounce(async (search) => {
      setIsFetching(true);
      try {
        const data = await func(search);
        setOptions(data.results || []);
      } finally {
        setIsFetching(false);
      }
    }, 500)
  , [func]);

  const handleAutoComplete = useCallback((search) => {
    if (search) {
      debouncedFetch(search);
    } else {
      setOptions([]);
    }
  }, [debouncedFetch]);

  const handleOnClick = () => {
    setOptions([]);
  }

  // Clean up debounce on unmount
  React.useEffect(() => {
    return () => debouncedFetch.cancel();
  }, [debouncedFetch]);

  return (
    <div className="d-flex search-multiple-retailer" style={containerStyle}>
      <Select
        style={styles}
        value={selectedValue}
        onSelect={value => {
          const v = options.find(option => option.id === value);
          const newValue = [...selectedValue, {label:v.name, value: v.id}];
          setSelectedValue(newValue);
          if(onSelect)
            onSelect(newValue)
        }}
        mode="multiple"
        onSearch={handleAutoComplete}
        onClick={handleOnClick}
        onDeselect={value => {
          const newValue = selectedValue.filter(option => option.value != value);
          setSelectedValue(newValue);
          if(onSelect)
            onSelect(newValue)
        }}
        placeholder={placeholder}
        notFoundContent={isLoading || isFetching ? <ClipLoader size={32} color="#006280" /> : null}
        options={options}
        fieldNames={{ label: 'name', value: 'id' }}
        optionFilterProp="name"
      />
      
    </div>
  );
};
